<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 4047 4047"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <g id="_804949296">
     <path class="fil0 str0"
           d="M23 1588c0,228 231,180 485,180l0 1492c0,154 146,117 342,117l0 -189 -153 0 0 -1519c0,-39 -24,-69 -53,-82 -39,-15 -341,-8 -397,-8l910 -797c78,-73 271,-227 337,-292l290 -250 1058 919c22,22 26,24 49,42 107,86 285,257 384,335 25,20 27,16 46,43 -56,0 -358,-7 -396,8 -30,13 -53,43 -53,82l0 1519c-201,0 -162,-41 -162,189 237,0 350,39 350,-135l0 -1474c159,0 377,28 451,-61 60,-72 48,-177 -27,-237l-803 -697c-25,-24 -40,-31 -63,-54 -26,-25 -38,-32 -63,-54l-687 -598c-47,-40 -95,-71 -158,-9l-221 193c-27,21 -33,27 -58,50l-386 333c-24,21 -29,29 -57,51 -23,18 -30,29 -51,47l-445 382c-24,23 -31,29 -57,51 -36,29 -72,66 -109,97l-222 192c-38,29 -81,68 -81,134z"/>
      <path class="fil0 str0"
            d="M1308 1795c0,70 29,99 99,99 71,0 209,-202 296,-261 14,166 6,37 2,181 -3,96 50,266 -77,292 -166,35 -364,-52 -507,69 -89,76 -127,232 -39,359 114,165 300,115 513,115l630 -1c173,1 162,181 9,181l-630 0c-127,0 -305,-21 -403,19 -213,85 -235,398 -3,503 101,46 666,26 820,26 69,0 138,0 207,0 180,-2 131,133 80,161 -47,25 -271,-4 -366,12 -118,19 -236,126 -236,267 0,153 -15,207 117,207 99,0 61,-196 79,-236 48,-105 349,25 528,-100 156,-108 156,-375 -52,-470 -89,-41 -281,-21 -402,-21l-630 0c-69,0 -125,-25 -125,-90 0,-125 200,-90 323,-90 141,0 282,0 423,0 213,0 400,45 518,-111 30,-40 55,-98 55,-158 0,-119 -74,-212 -160,-252 -92,-43 -263,-27 -395,-27 -63,0 -683,14 -725,-12 -58,-35 -60,-154 50,-159l269 -1c115,-6 219,-17 289,-152 23,-44 27,-83 27,-152 -1,-123 0,-246 0,-369 47,32 148,143 195,191 31,31 63,74 112,76 50,3 97,-42 97,-96 0,-54 -178,-210 -222,-254 -37,-37 -214,-231 -254,-231 -102,0 -121,53 -227,159 -26,26 -33,42 -58,68 -42,43 -79,79 -122,121 -31,31 -105,86 -105,137z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'HeatingPump',
};
</script>

<style scoped>
.str0 {
  stroke: #EB7087;
  stroke-width: 45.4673
}

.fil0 {
  fill: #EB7087
}
</style>
